<div class="navbar">
  <div class="navbar_top" role="tablist">
    <button
      mat-button
      role="tab"
      aria-selected="false"
      aria-label="Home"
      [attr.aria-current]="selectedPage === 1 ? 'page' : false"
      [ngClass]="{
        'unselected-button': !selectedRoute?.includes('home'),
        'selected-button': selectedRoute?.includes('home'),
        'text-align-l': showText
      }"
      (click)="onClick('home', 1)">
      <mat-label *ngIf="showText"> Home</mat-label>
    </button>
    <button
      mat-button
      role="tab"
      aria-selected="false"
      aria-label="Console"
      [attr.aria-current]="selectedPage === 2 ? 'page' : false"
      *ngIf="authenticated"
      [ngClass]="{
        'unselected-button': !selectedRoute?.includes('console'),
        'selected-button': selectedRoute?.includes('console') || selectedRoute?.includes('app-details'),
        'text-align-l': showText
      }"
      (click)="onClick('console', 2)">
      <mat-label *ngIf="showText">Console</mat-label>
    </button>
    <button
      mat-button
      role="tab"
      aria-selected="false"
      aria-label="API Catalog"
      [attr.aria-current]="selectedPage === 3 ? 'page' : false"
      [ngClass]="{
        'unselected-button': !selectedRoute?.includes('apis'),
        'selected-button': selectedRoute?.includes('apis'),
        'text-align-l': showText
      }"
      (click)="onClick('apis', 3)">
      <mat-label *ngIf="showText">API Catalog</mat-label>
    </button>
    <button
      mat-button
      aria-label="FAQ - Frequently Asked Questions"
      role="tab"
      aria-selected="false"
      [attr.aria-current]="selectedPage === 4 ? 'page' : false"
      [ngClass]="{
        'unselected-button': !selectedRoute?.includes('faqs'),
        'selected-button': selectedRoute?.includes('faqs'),
        'text-align-l': showText
      }"
      (click)="onClick('faqs', 4)">
      <mat-label *ngIf="showText">FAQ</mat-label>
    </button>
  </div>
  <div>
    <button mat-button *ngIf="authenticated" aria-label="Contact us" (click)="contactUs()">
      <img src="./assets/images/icons/contact_icon_large.svg" alt="Contact" width="25" height="25" />
      <mat-label *ngIf="showText"> Contact</mat-label>
    </button>
  </div>
</div>
